import { render, staticRenderFns } from "./InstituteChain.vue?vue&type=template&id=a7bd074e"
import script from "./InstituteChain.vue?vue&type=script&lang=js"
export * from "./InstituteChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports